import {settingConsts} from "../../const";

export function settings (state = {}, action) {
  switch (action.type) {
    case settingConsts.LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case settingConsts.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.settings
      };
    case settingConsts.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}
